import { useEffect, useState } from "react";
import { useParams } from "react-router-dom";
import { fetchProfileById } from "./api";
import { FaUserCircle, FaClock, FaMapMarkerAlt } from 'react-icons/fa';
import "../../scss/cdp-profile.scss";

const ProfileDetail = () => {
  const { id } = useParams();
  const [profile, setProfile] = useState(null);
  const [activeTab, setActiveTab] = useState('PERSONAL');

  useEffect(() => {
    const loadProfile = async () => {
      const data = await fetchProfileById(id);
      setProfile(data);
    };
    loadProfile();
  }, [id]);

  if (!profile) return <div className="loading">Loading...</div>;

  const tabs = ['PERSONAL', 'SESSIONS', 'ANALYTICS', 'E-COMMERCE', 'LOGS', 'JSON'];
  const subtabs = ['PII', 'CONTACTS', 'TRAITS', 'LAST GEO', 'MEDIA', 'AUX'];

  return (
    <div className="tracardi-profile">
      {/* Header */}
      <div className="profile-title">
        {profile.properties?.displayName} ({profile.properties?.email})
      </div>

      {/* Main Navigation */}
      <div className="main-tabs">
        {tabs.map((tab) => (
          <button 
            key={tab}
            className={activeTab === tab ? 'active' : ''}
            onClick={() => setActiveTab(tab)}
          >
            {tab}
          </button>
        ))}
      </div>

      <div className="profile-content">
        {/* Left Column */}
        <div className="profile-main-info">
          {/* Profile Image and Basic Info */}
          <div className="profile-basic-info">
            {profile.properties?.profileImage ? (
              <img src={profile.properties.profileImage} alt="Profile" className="profile-image" />
            ) : (
              <FaUserCircle className="default-profile-icon" />
            )}
            <div className="basic-details">
              <div className="info-row">
                <span className="label">Name</span>
                <span>{profile.properties?.displayName}</span>
              </div>
              <div className="info-row">
                <span className="label">
                  <FaClock /> Last visit
                </span>
                <span>{new Date(profile.metadata?.last_visit).toLocaleString()} - {profile.metadata?.time_live}</span>
              </div>
              <div className="info-row">
                <span className="label">
                  <FaMapMarkerAlt /> Location
                </span>
                <span>{profile.properties?.location || 'N/A'}</span>
              </div>
            </div>
          </div>

          {/* Profile Metadata */}
          <div className="metadata-section">
            <h3>Profile metadata</h3>
            <div className="metadata-grid">
              <div className="info-row">
                <span className="label">Primary Id</span>
                <span>{profile.itemId || 'None'}</span>
              </div>
              <div className="info-row">
                <span className="label">Anonymous Id</span>
                <span className="monospace">{profile.anonymousId}</span>
              </div>
              <div className="info-row">
                <span className="label">Created</span>
                <span>{new Date(profile.metadata?.created).toLocaleString()}</span>
              </div>
              <div className="info-row">
                <span className="label">Updated</span>
                <span>{new Date(profile.metadata?.updated).toLocaleString()}</span>
              </div>
              <div className="info-row">
                <span className="label">Status</span>
                <div className="status-tags">
                  <span className="status-tag active">Active</span>
                  {profile.metadata?.merged_with && <span className="status-tag merged">Merged</span>}
                </div>
              </div>
            </div>
          </div>

          {/* Sub Navigation */}
          <div className="sub-tabs">
            {subtabs.map((tab) => (
              <button key={tab}>{tab}</button>
            ))}
          </div>

          {/* PII Information */}
          <div className="pii-section">
            <div className="info-row">
              <span className="label">Firstname</span>
              <span>{profile.properties?.firstName}</span>
            </div>
            <div className="info-row">
              <span className="label">Lastname</span>
              <span>{profile.properties?.lastName}</span>
            </div>
            <div className="info-row">
              <span className="label">Display name</span>
              <span>{profile.properties?.displayName}</span>
            </div>
          </div>
        </div>

        {/* Right Column - Events Timeline */}
        <div className="events-timeline">
          <h3>Last events</h3>
          {profile.events?.map((event, index) => (
            <div key={index} className="event-item">
              <div className="event-time">
                <FaClock />
                {new Date(event.timestamp).toLocaleString()}
                <span className="time-ago">- {event.timeAgo}</span>
              </div>
              <div className="event-type">{event.type}</div>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
};

export default ProfileDetail;
